import React, { useState } from 'react';
import '../../../entrydoor.css';

const ExteriorFinishSideLiteEticom = ({ value, onChange, label = 'Exterior Finish:', disabled = false }) => {
    const [selectedExteriorFinishSideLiteEticom, setSelectedExteriorFinishSideLiteEticom] = useState(value || "White");

    const handleExteriorFinishSideLiteEticomChange = (e) => {
        setSelectedExteriorFinishSideLiteEticom(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} disabled={disabled} htmlFor="ExteriorFinishSideLiteEticom">{label}</label>
            <select style={{ display: "none" }}
                disabled={disabled}
                id="ExteriorFinishSideLiteEticom"
                value={selectedExteriorFinishSideLiteEticom}
                onChange={handleExteriorFinishSideLiteEticomChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="White">{selectedExteriorFinishSideLiteEticom === "White" ? "White ✔" : "White"}</option>
                <option value="Gentek">{selectedExteriorFinishSideLiteEticom === "Gentek" ? "Gentek ✔" : "Gentek"}</option>
            </select>
        </div>
    );
};

export default ExteriorFinishSideLiteEticom;
